import httpRequest from 'httpRequest'
import { LoyaltyRedeemPointRuleSettingContract } from 'models'
import { LoyalManagementContract } from 'models'

const PREFIX = '/location/loyalty-management'

const loyaltyManagementService = {
    getLoyaltyManagement: () =>
        httpRequest.get<LoyalManagementContract>(PREFIX),
    updateLoyaltyManagement: (contract: LoyalManagementContract) =>
        httpRequest.put(PREFIX, contract),
    getLoyalPointRedemption: () =>
        httpRequest.get<LoyaltyRedeemPointRuleSettingContract>(
            `${PREFIX}/redeem-point-setting`,
        ),
}
export default loyaltyManagementService
